import Process from "./Process";

const BLOB_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/optimized_blender_imgs/";

const ProcessPage = () => {
  return (
    <div className="animate-[page-in_.35s_ease]">
      <Process
        frameCount={133}
        getFrameSrc={(i) => `${BLOB_BASE_URL}${i + 1}.jpg`}
        pixelsPerFrame={9}
      />
    </div>
  );
};
export default ProcessPage;
